export default __webpack_public_path__ + "static/media/cc_red.e780a65f.jpg";